// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"260ecc91","455":"042c40ba","977":"6693eba3"}[chunkId] + ".chunk.js";
};